// ═══════════════════════════════════════════════════════════════
// frontend/src/hooks/useAuth.ts — Auth context for the app
// ═══════════════════════════════════════════════════════════════

import { createContext, useContext } from "react";

export interface User {
  id: number;
  name: string;
  email: string;
}

interface AuthContextType {
  user: User | null;
  loading: boolean;
  login: () => void;
  logout: () => void;
}

export const AuthContext = createContext<AuthContextType>({
  user: null,
  loading: false,
  login: () => {},
  logout: () => {},
});

export function useAuth() {
  return useContext(AuthContext);
}
